// src/utils/userManagement.js
import { 
    doc, 
    setDoc, 
    updateDoc, 
    getDoc, 
    serverTimestamp 
  } from "firebase/firestore";
  import { db } from "../firebase";
  
  export async function updateUserRole(userId, isInstructor) {
    const userRef = doc(db, "users", userId);
    return updateDoc(userRef, {
      isInstructor: isInstructor,
      updatedAt: serverTimestamp()
    });
  }
  
  export async function getUserRole(userId) {
    const userRef = doc(db, "users", userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      throw new Error("User not found");
    }
    
    return {
      isInstructor: userDoc.data().isInstructor || false
    };
  }
  
  export async function createUserWithRole(userId, userData, isInstructor = false) {
    const userRef = doc(db, "users", userId);
    return setDoc(userRef, {
      ...userData,
      isInstructor: isInstructor,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      subscriptionTier: userData.subscriptionTier || "free",
      organizationId: userData.organizationId || null,
      seatId: userData.seatId || null,
    });
  }

  /**
   * Returns the effective subscription tier for a user, taking into account
   * whether their tier comes from an organization seat or a personal subscription.
   */
  export async function getEffectiveTier(userId) {
    const userRef = doc(db, "users", userId);
    const userDoc = await getDoc(userRef);

    if (!userDoc.exists()) return { tier: "free", source: "default" };

    const data = userDoc.data();
    const tier = data.subscriptionTier || "free";

    if (data.organizationId && data.seatId && tier !== "free") {
      return { tier, source: "organization", organizationId: data.organizationId };
    }

    if (data.stripeCustomerId && data.subscriptionStatus === "active") {
      return { tier, source: "personal" };
    }

    return { tier, source: tier === "free" ? "default" : "unknown" };
  }